import { EventEmitter } from './EventEmitter';
import { HTTPConnection } from './connection-strategy/HTTPConnection';
import { SENDER } from './constants';
import { StorageService } from './services/storage.service';
import { WebSocketConnection } from './connection-strategy/WebSocketConnection';
import { messageParser } from './message-parser/messageParser';
import { parseChatHistory } from './message-parser/utils/parse-chat-history';
import { v4 as uuidv4 } from 'uuid';
export class Rasa extends EventEmitter {
    constructor({ url, protocol = 'ws', initialPayload, authenticationToken, senderId }) {
        super();
        this.onBotResponse = (data) => {
            const timestamp = new Date();
            this.storageService.setMessage(Object.assign(Object.assign({ sender: SENDER.BOT }, data), { timestamp }), this.sessionId);
            this.trigger('message', messageParser(Object.assign(Object.assign({}, data), { timestamp }), SENDER.BOT));
        };
        this.onSessionConfirm = () => {
            if (this.isSessionConfirmed) {
                return;
            }
            this.isSessionConfirmed = true;
            const sessionStart = new Date();
            const isContinuesSession = this.storageService.setSession(this.sessionId, sessionStart);
            this.trigger('sessionConfirm');
            if (!isContinuesSession) {
                this.trigger('message', {
                    type: 'sessionDivider',
                    startDate: sessionStart,
                });
                if (this.initialPayload) {
                    this.connection.sendMessage(this.initialPayload, this.sessionId);
                }
            }
        };
        this.onConnect = (isReconnected = false) => {
            if (isReconnected) {
                this.connection.sessionRequest(this.sessionId);
                this.trigger('connect');
                return;
            }
            this.sessionId = this.senderId ? this.senderId : uuidv4();
            this.connection.sessionRequest(this.sessionId);
            if (this.isInitialConnection) {
                this.loadChatHistory();
                this.isInitialConnection = false;
            }
            this.trigger('connect');
        };
        this.onDisconnect = () => {
            this.isSessionConfirmed = false;
            this.isInitialConnection = true;
            this.trigger('disconnect');
        };
        this.overrideChatHistory = (chatHistoryString) => {
            this.storageService.overrideChatHistory(chatHistoryString);
            this.loadChatHistory();
        };
        this.senderId = senderId;
        this._sessionId = senderId ? senderId : uuidv4();
        this.initialPayload = initialPayload;
        this.storageService = new StorageService();
        this.isInitialConnection = true;
        this.isSessionConfirmed = false;
        const Connection = protocol === 'ws' ? WebSocketConnection : HTTPConnection;
        const { onConnect, onDisconnect, onBotResponse, onSessionConfirm } = this;
        this.connection = new Connection({
            url,
            authenticationToken,
            onConnect,
            onDisconnect,
            onBotResponse,
            onSessionConfirm,
        });
    }
    get sessionId() {
        return this._sessionId;
    }
    set sessionId(value) {
        this._sessionId = value;
    }
    loadChatHistory() {
        const chatHistory = this.storageService.getChatHistory() || [];
        this.trigger('loadHistory', parseChatHistory(chatHistory));
    }
    connect() {
        this.connection.connect();
    }
    disconnect() {
        this.connection.disconnect();
    }
    sendMessage({ text, reply, timestamp }, isQuickReply = false, messageKey) {
        this.connection.sendMessage(reply !== null && reply !== void 0 ? reply : text, this.sessionId);
        this.storageService.setMessage({ sender: SENDER.USER, text, timestamp }, this.sessionId);
        if (isQuickReply && messageKey && reply) {
            this.storageService.setQuickReplyValue(reply, messageKey, this.sessionId);
        }
    }
    reconnection(value) {
        this.connection.reconnection(value);
    }
    getChatHistory() {
        return JSON.stringify(this.storageService.getChatHistory());
    }
}
export * from './errors';
export * from './message-parser';
export * from './constants';
//# sourceMappingURL=index.js.map